import React, { useState } from 'react';
import { TrashIcon, DatabaseIcon, RefreshIcon, DownloadIcon, CalendarIcon, CheckIcon, AlertIcon } from './Icons';
import { useNotification } from './Notification';

function ActionsDev() {
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportDates, setExportDates] = useState({
    dateStart: '',
    dateEnd: ''
  });
  const { showNotification, showConfirm } = useNotification();

  const handleDeleteAllLogs = async () => {
    const confirmed1 = await showConfirm('ATTENTION : Êtes-vous sûr de vouloir supprimer TOUS les logs ? Cette action est irréversible !');
    if (!confirmed1) return;

    const confirmed2 = await showConfirm('Confirmation finale : Tous les logs seront définitivement supprimés. Continuer ?');
    if (!confirmed2) return;

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/logs', {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        showNotification('Tous les logs ont été supprimés avec succès', 'success');
      } else {
        const data = await response.json();
        showNotification(`Erreur: ${data.error || 'Échec de la suppression'}`, 'error');
      }
    } catch (error) {
      console.error('Erreur suppression logs:', error);
      showNotification('Erreur lors de la suppression', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleExportLogs = async () => {
    if (!exportDates.dateStart && !exportDates.dateEnd) {
      showNotification('Veuillez sélectionner au moins une date de début ou de fin', 'warning');
      return;
    }

    setExportLoading(true);
    try {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();
      if (exportDates.dateStart) params.append('date_start', exportDates.dateStart);
      if (exportDates.dateEnd) params.append('date_end', exportDates.dateEnd);

      const response = await fetch(`/api/logs/export?${params}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const dateStr = new Date().toISOString().split('T')[0];
        a.download = `logs_export_${dateStr}.db`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        showNotification('Export réussi !', 'success');
      } else {
        const data = await response.json();
        showNotification(`Erreur: ${data.error || 'Échec de l\'export'}`, 'error');
      }
    } catch (error) {
      console.error('Erreur export logs:', error);
      showNotification('Erreur lors de l\'export', 'error');
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="actions-dev-container">
      <div style={{ marginBottom: '30px' }}>
        <h1 style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '12px',
          color: '#e5e7eb',
          fontSize: '28px',
          marginBottom: '10px'
        }}>
          <DatabaseIcon size={32} />
          Actions Développeur
        </h1>
        <p style={{ color: '#9ca3af', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
          <AlertIcon size={18} style={{ color: '#f59e0b' }} />
          Zone réservée aux administrateurs - Actions sensibles et irréversibles
        </p>
      </div>

      <div className="dev-actions-grid">
        {/* Section Logs */}
        <div className="dev-action-card">
          <div className="dev-action-header">
            <TrashIcon size={24} />
            <h3>Gestion des Logs</h3>
          </div>
          <p className="dev-action-description">
            Suppression complète de tous les logs de la base de données. 
            Cette action est définitive et ne peut pas être annulée.
          </p>
          <button 
            className="btn btn-danger-large" 
            onClick={handleDeleteAllLogs}
            disabled={loading}
          >
            <TrashIcon size={20} />
            {loading ? 'Suppression en cours...' : 'Supprimer tous les logs'}
          </button>
        </div>

        {/* Section Export */}
        <div className="dev-action-card">
          <div className="dev-action-header">
            <DownloadIcon size={24} />
            <h3>Export des Logs</h3>
          </div>
          <p className="dev-action-description">
            Exporter les logs dans un fichier de base de données SQLite (.db) pour une plage de dates spécifique.
            Laissez vide pour exporter tous les logs.
          </p>
          <div className="export-dates-container">
            <div className="export-date-field">
              <label>
                <CalendarIcon size={16} />
                Date de début
              </label>
              <input
                type="datetime-local"
                value={exportDates.dateStart}
                onChange={(e) => setExportDates(prev => ({ ...prev, dateStart: e.target.value }))}
                className="export-date-input"
              />
            </div>
            <div className="export-date-field">
              <label>
                <CalendarIcon size={16} />
                Date de fin
              </label>
              <input
                type="datetime-local"
                value={exportDates.dateEnd}
                onChange={(e) => setExportDates(prev => ({ ...prev, dateEnd: e.target.value }))}
                className="export-date-input"
              />
            </div>
          </div>
          <button 
            className="btn btn-primary-large" 
            onClick={handleExportLogs}
            disabled={exportLoading}
          >
            <DownloadIcon size={20} />
            {exportLoading ? 'Export en cours...' : 'Exporter les logs'}
          </button>
        </div>

        {/* Section Maintenance */}
        <div className="dev-action-card">
          <div className="dev-action-header">
            <RefreshIcon size={24} />
            <h3>Maintenance</h3>
          </div>
          <p className="dev-action-description">
            Outils de maintenance et d'optimisation de la base de données.
          </p>
          <button className="btn btn-secondary-large" disabled>
            <DatabaseIcon size={20} />
            Optimiser la base (Bientôt)
          </button>
        </div>
      </div>
    </div>
  );
}

export default ActionsDev;
